import { createAction } from '@reduxjs/toolkit';

import {
  RECIPIENTS_RESET,
  RECIPIENTS_GET_REQUEST,
  RECIPIENTS_GET_SUCCESS,
  RECIPIENTS_GET_FAILURE,
} from './recipients.const';

export const recipientsResetAction = createAction(RECIPIENTS_RESET);

export const recipientsGetRequestAction = createAction(RECIPIENTS_GET_REQUEST);
export const recipientsGetSuccessAction = createAction(RECIPIENTS_GET_SUCCESS);
export const recipientsGetFailureAction = createAction(RECIPIENTS_GET_FAILURE);
